import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { Tag } from "@design-system/Tag/Tag";
import { ORGANIZATION_MEMBER_ACCESS_LOG_SOURCE_LABELS } from "../organizationMemberAccessLogSourceLabels";
import { MemberAccessLogRow } from "../memberAccessLogRow";

export const SourceCell = memo(
    ({ row }: CellContext<ViewTableFeatures, MemberAccessLogRow, unknown>) => (
        <Tag size="sm" color="neutral" outline>
            {ORGANIZATION_MEMBER_ACCESS_LOG_SOURCE_LABELS[row.original.source]}
        </Tag>
    ),
);
